import Chinese from './chinese/Router'

/*
 * Syntax: path: Component
 * Example: chinese: Chinese
 */
export default {
  chinese: Chinese,
}
